/**
 * Language selection models for the Web Transcribe Streaming system
 * Requirements: 8.1, 8.2
 */

/**
 * Represents a language option for transcription
 */
export interface LanguageOption {
  /** Display code (e.g., 'en', 'fr', 'ko') */
  code: string;
  /** Human-readable language name */
  name: string;
  /** Amazon Transcribe language code */
  transcribeCode: string;
}

/**
 * Session configuration including language and audio settings
 */
export interface SessionConfig {
  /** Selected language for transcription */
  language: LanguageOption;
  /** Audio format (e.g., 'pcm') */
  audioFormat: string;
  /** Audio sample rate in Hz */
  sampleRate: number;
}

/**
 * Supported languages for Amazon Transcribe
 * Maps to Amazon Transcribe language codes: en-US, fr-FR, ko-KR
 */
export const SUPPORTED_LANGUAGES: LanguageOption[] = [
  {
    code: 'en',
    name: 'English',
    transcribeCode: 'en-US',
  },
  {
    code: 'fr',
    name: 'French',
    transcribeCode: 'fr-FR',
  },
  {
    code: 'ko',
    name: 'Korean',
    transcribeCode: 'ko-KR',
  },
];

/**
 * Default language (English) when no selection is made
 */
export const DEFAULT_LANGUAGE: LanguageOption = SUPPORTED_LANGUAGES[0];
